/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleInfoFill: {
  name: 'triangle-info-fill';
  data: string;
} = {
  name: 'triangle-info-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.73 1.994c-.77-1.33-2.69-1.33-3.46 0L1.003 17.998C.232 19.33 1.194 21 2.734 21h18.532c1.54 0 2.502-1.669 1.73-3.002L13.731 1.994ZM12 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 0 0-2 0v4a1 1 0 1 0 2 0v-4Z" fill="currentColor"/></svg>`,
};
